import { add, addHours, getTime, parse, format } from 'date-fns';

export const formatDateTime = (dateString: string, timeString: string) => {
    if (!dateString && !timeString) return getTime(new Date());

    const parsedDate = parse(dateString, 'dd.MM.yyyy', new Date());
    const parsedTime = parse(timeString, 'h:mm:ss a', new Date());

    const newDate = new Date(
        parsedDate.getFullYear(),
        parsedDate.getMonth(),
        parsedDate.getDate(),
        parsedTime.getHours(),
        parsedTime.getMinutes(),
        parsedTime.getSeconds(),
    );

    return getTime(newDate);
};

export const getEventData = (item: any) => {
    const minutes = new Date(Number(item.timestamp)).getMinutes();
    const seconds = new Date(Number(item.timestamp)).getSeconds();
    const left = ((minutes + seconds / 60) / 60) * 100;
    const duration = item.recordMetadata.workTime;
    const width = (duration / 60 / 60) * 100;

    return { left, duration, width };
};

export function addOneHourToTime(timeString: string) {
    const parsedTime = parse(timeString, 'h:mm:ss a', new Date());
    const newTimePlusOneHour = add(parsedTime, { hours: 1 });
    return format(newTimePlusOneHour, 'h a');
}

export const parseDateToISO = (dateStr: string) => {
    const [day, month, year] = dateStr.split('.');
    return new Date(`${year}-${month}-${day}`);
};
